document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('shopify-section-template--27900919447891__custom_liquid_4qgPac');
  const menu   = document.getElementById('shopify-section-template--27900919447891__image_with_text_overlay_PpU47w');

  if (!header) return;

  const root = document.documentElement;

  function sync() {
    const headerH = header.getBoundingClientRect().height;
    root.style.setProperty('--headerH', `${headerH}px`);

    if (menu) {
      const menuH = menu.getBoundingClientRect().height;
      root.style.setProperty('--menuH', `${menuH}px`);
    }
  }

  sync();

  const ro = new ResizeObserver(sync);
  ro.observe(header);
  if (menu) ro.observe(menu);

  window.addEventListener('resize', sync);
  document.addEventListener('shopify:section:load', sync);
});




